// extracted by mini-css-extract-plugin
export default {"container":"SocialHandles_container__vp3hE","link":"SocialHandles_link__d-zLz"};